/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password?: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    lastActiveAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    type?: UserTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    uuid?: string;
}


/**
 * @export
 */
export const UserTypeEnum = {
    Admin: 'ADMIN',
    Recruiter: 'RECRUITER',
    Applicant: 'APPLICANT'
} as const;
export type UserTypeEnum = typeof UserTypeEnum[keyof typeof UserTypeEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'password': json['password'] == null ? undefined : json['password'],
        'lastActiveAt': json['lastActiveAt'] == null ? undefined : (new Date(json['lastActiveAt'])),
        'type': json['type'] == null ? undefined : json['type'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
    };
}

  export function UserToJSON(json: any): User {
      return UserToJSONTyped(json, false);
  }

  export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'password': value['password'],
        'lastActiveAt': value['lastActiveAt'] == null ? undefined : ((value['lastActiveAt']).toISOString()),
        'type': value['type'],
        'isActive': value['isActive'],
        'uuid': value['uuid'],
    };
}

